import { Box, Textarea, TextareaProps } from '@mantine/core';

import InputLabel from 'components/input-label';
import classes from './index.module.css';

interface ICustomTextarea extends TextareaProps {
  info?: string;
  label: string;
}

const CustomTextarea = ({
  autosize = true,
  info,
  label,
  maxRows = 4,
  minRows = 4,
  required,
  ...props
}: ICustomTextarea) => {
  return (
    <Box>
      <InputLabel label={label} required={required} info={info} />
      <Textarea
        classNames={{ input: classes.input }}
        mb={6}
        withAsterisk={required}
        minRows={minRows}
        maxRows={maxRows}
        autosize={autosize}
        {...props}
      />
    </Box>
  )
}

export default CustomTextarea;